<div class="card border-0 shadow-sm">
  <!-- Header -->
  <div class="card-header bg-white">
    <h5 class="mb-0 fw-semibold">
      <i class="bi bi-box-seam-fill text-primary me-2"></i>
      Subscription Settings
    </h5>
  </div>

  <div class="card-body">
    @if (isLoading) {
      <div class="text-center py-4 text-muted">
        <div class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></div>
        Loading subscription settings...
      </div>
    } @else {
      @if (paymentStatus?.trialActive) {
        <div class="alert alert-success mb-4">
          Your practice's one-month free trial is active until
          {{ paymentStatus?.trialEndsOn | date: 'dd MMM yyyy' }}.
        </div>
      } @else if (paymentStatus?.paymentRequired) {
        <div
          class="alert alert-warning d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4"
        >
          <div>
            <div class="fw-semibold">
              {{
                paymentStatus?.latestInvoiceFailed
                  ? 'Practice subscription payment failed'
                  : 'Practice subscription payment due'
              }}
            </div>
            <small>
              R{{ paymentStatus?.amount | number: '1.2-2' }}
              {{
                paymentStatus?.latestInvoiceFailed
                  ? 'can be retried now.'
                  : 'is due by ' + (paymentStatus?.payByDate | date: 'dd MMM yyyy') + '.'
              }}
            </small>
          </div>
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="isStartingPayment"
            (click)="payWithYoco()"
          >
            <i class="bi bi-box-arrow-up-right me-1"></i>
            {{
              isStartingPayment
                ? 'Opening Yoco...'
                : paymentStatus?.latestInvoiceFailed
                  ? 'Retry with Yoco'
                  : 'Pay with Yoco'
            }}
          </button>
        </div>
      }

      @if (currentSubscription) {
        <div class="alert alert-light border mb-4">
          <div class="row g-3">
            <div class="col-md-4">
              <div class="text-muted small">Current Package</div>
              <div class="fw-semibold">{{ currentSubscription.packageName }}</div>
            </div>

            <div class="col-md-4">
              <div class="text-muted small">Status</div>
              <div class="fw-semibold text-capitalize">{{ currentSubscription.status }}</div>
            </div>

            <div class="col-md-4">
              <div class="text-muted small">Next Billing Date</div>
              <div class="fw-semibold">
                {{ currentSubscription.nextBillingDate | date: 'dd MMM yyyy' }}
              </div>
            </div>
          </div>
        </div>
      }

      <div>
        <h6 class="fw-semibold mb-3">Invoice History</h6>

        @if (isInvoicesLoading) {
          <div class="text-muted small py-2">Loading invoices...</div>
        } @else if (invoices.length === 0) {
          <div class="text-muted small py-2">No subscription invoices have been issued yet.</div>
        } @else {
          <div class="list-group list-group-flush border rounded">
            @for (invoice of invoices; track invoice.id) {
              <div
                class="list-group-item d-flex justify-content-between align-items-center gap-3 py-3"
              >
                <div class="min-w-0">
                  <div class="fw-semibold">{{ invoice.invoiceNumber }}</div>
                  <div class="text-muted small">
                    {{ invoice.description || (invoice.invoiceDate | date: 'MMMM yyyy') }}
                  </div>
                </div>
                <div class="text-end flex-shrink-0">
                  <div class="fw-semibold">
                    {{ invoice.invoiceCurrency || 'ZAR' }}
                    {{ invoice.invoiceAmount | number: '1.2-2' }}
                  </div>
                  <span class="badge" [class]="invoiceStatusClass(invoice.status)">{{
                    invoice.status | titlecase
                  }}</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>
